import Icon from '../components/Icon.vue'

Icon.register({
  minus: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 208H32C14.3 208 0 222.3 0 240V272C0 289.7 14.3 304 32 304H416C433.7 304 448 289.7 448 272V240C448 222.3 433.7 208 416 208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/minus.js
// module id = 73KA
// module chunks = 144